"use client";
import { useContext } from "react";
import DropDown from "./DropDown";
import { icons } from "./icons";
import { AppContext } from "./AppContext";

export default function Duration() {
  const { config, duration, setDuration, animationType, setAnimationType } =
    useContext(AppContext);
  const isActive = () => {
    let ret = false;
    config.forEach((c) => {
      Object.keys(c).forEach((k) => {
        if (c[k].length > 1) {
          ret = true;
        }
      });
    });
    return ret;
  };

  const durations = [
    "2s",
    "5s",
    "10s",
    "15s",
    "20s",
    "25s",
    "30s",
    "40s",
    "50s",
    "60s",
    "100s",
    "200s",
  ];
  const types = ["alternate", "alternate-reverse", "normal"];
  return (
    <div className="overflow-hidden">
      <div className="title">Animation Settings</div>

      <div className="border-color relative flex flex-col overflow-hidden rounded border">
        {!isActive() && (
          <div className="absolute inset-0 z-50 -mt-px bg-white opacity-50 dark:bg-dark-900"></div>
        )}
        <div className="colorItem flex items-center justify-between p-2">
          <div className="flex items-center gap-2">
            <div className="iw">{icons.clock}</div>
            Duration
          </div>
          <DropDown
            value={duration}
            values={durations}
            onChange={(e) => setDuration(e)}
          />
        </div>
        <div className="colorItem border-color mt-px flex items-center justify-between border-t p-2">
          <div className="flex items-center gap-2">
            <div className="iw">{icons.direction}</div>
            Direction
          </div>
          <div className="min-w-[150px]">
            <DropDown
              value={animationType}
              values={types}
              onChange={(e) => setAnimationType(e)}
            />
          </div>
        </div>
      </div>
    </div>
  );
}
